import type { EditOp, ResolvedEdit, SoundRole } from "../contracts/edit-graph.js";
import type { Milli } from "../contracts/ids.js";

/** Audible for scoring/preview: not silence and volume above zero. */
export function isAudibleSound(sound: {
  role: SoundRole;
  volumeMilli: Milli;
}): boolean {
  return sound.role !== "silence" && sound.volumeMilli > 0;
}

/**
 * Effective sound under last-wins resolve (0 or 1 entry in `resolved.sounds`).
 * Same value preview/mood/score must consume.
 */
export function effectiveSound(
  resolved: ResolvedEdit,
): Extract<EditOp, { kind: "sound" }> | null {
  return resolved.sounds[resolved.sounds.length - 1] ?? null;
}
